import { useTranslation } from 'react-i18next';

const LoadingScreen = ({ show }: { show: boolean }) => {
  const { t } = useTranslation();
  if (show === true) return <h3>{t('loading.heading')}</h3>;
  else return null;
};

export default LoadingScreen;
